<template>
  <div>    
    <div class="widget-container">
     
      <DxForm
        id="form"
        :form-data="state.formData"
        label-mode='outside'
        :read-only='false'
        :show-colon-after-label='true'
        label-location='top'
        :min-col-width='300'
        :col-count='1'
        ref="formMaster"
      >

      <DxGroupItem caption="Βασικά Στοιχεία" :col-span="2" :col-count="2">
        <DxSimpleItem 
          data-field="description"
          :is-required="true"
        >
            <DxLabel text="Περιγραφή Διαδρομής"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="area_geo_location_id"
          editor-type="dxSelectBox"
          :editor-options="{
            dataSource: state.LookupCustomDS_serres_geo_locations,
            displayExpr: 'descr',
            valueExpr:'geo_location_id'
          }"
        >
          <DxLabel text="Γεωγραφική Περιοχή"/>
        </DxSimpleItem>


        <DxSimpleItem
              data-field="total_distance_nm"
          >
            <DxLabel text="Συνολικό Μήκος Διαδρομής (Nm)"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="itinerary_link_1"
        >
            <DxLabel text="Σύνδεσμος Διαδρομής"/>
            <!-- <DxRequiredRule message="Υποχρεωτικό πεδίο" /> -->
        </DxSimpleItem>
      </DxGroupItem>


      </DxForm>

      <div class="dx-fieldset-header">Σημεία Διαδρομής</div>

      <div class="dx-fieldset grid-map-container">
        <div class="grid">
                <DxDataGrid
                    :key-expr="id"
                    :data-source="state.CustomStoreDetail"
                    :columns="columns"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :row-alternation-enabled="true"
                    :focused-row-enabled="true"
                    :width="gridWidth"
                    :style="{ 'max-width': maxWidth }"
                    ref="gridDetail"
                    :word-wrap-enabled="true"

                    @exporting="onExporting"
                    @rowClick="openForm"
                    @init-new-row="onInitNewRow"
                    @row-validating="onRowValidating"

                    v-model:focused-row-key="focusedRowKey"
                    @focused-row-changing="onFocusedRowChanging"
                    @focused-row-changed="onFocusedRowChanged"

                >
                <DxPaging 
                        :enabled="true"
                        :page-size="5"
                    />

                    <DxFilterRow :visible="true"/>
                    <DxHeaderFilter :visible="true"/>
        
                    <DxPager
                        :visible="true"
                        :allowed-page-sizes="pageSizes"
                        :display-mode="displayMode"
                        :show-page-size-selector="true"
                        :show-info="true"
                        :show-navigation-buttons="true"
                    />

                    <DxGroupPanel :visible="false"/>
                    <DxSorting mode="multiple"/>

                    <DxEditing
                        :allow-updating="true"
                        :allow-adding="true"
                        :allow-deleting="true"
                        mode="batch"
                    />

                    <DxColumn
                        data-field="google_map_point"
                        caption="Συντεταγμένες"
                        :visible="false"
                    >
                        <DxRequiredRule 
                            message="Υποχρεωτικό πεδίο"
                        />
                    </DxColumn>

                    <DxColumn
                        data-field="point_title"
                        caption="Όνομα Σημείου"
                    >
                        <DxRequiredRule 
                            message="Υποχρεωτικό πεδίο"
                        />
                    </DxColumn>

                    <DxColumn
                        data-field="point_description"
                        caption="Περιγραφή Σημείου"
                    >
                    </DxColumn>

                    <DxColumn
                        data-field="point_link_1"
                        caption="Σύνδεσμος Σημείου 1"
                        :hiding-priority="100"
                    >
                    </DxColumn>

                    <!--
                    <DxColumn
                        data-field="point_link_2"
                        caption="Σύνδεσμος Σημείου 2"
                    >
                    </DxColumn>
                    -->

                    <DxColumn
                        data-field="distance_nm"
                        caption="Απόσταση (Nm)"
                        :width="100"
                        :hiding-priority="110"
                    >
                    </DxColumn>

                    <DxColumn
                        data-field="order_ind"
                        caption="Σειρά Εμφάνισης"
                        :width="100"
                    >
                    </DxColumn>
                    
                </DxDataGrid>
              </div>
              
              <div class="map">
                  <GMapMap
                      :center="centerOfMap"
                      :zoom="zoom"
                      :options="{
                            zoomControl: true,
                            mapTypeControl: true,
                            scaleControl: true,
                            streetViewControl: true,
                            rotateControl: true,
                            fullscreenControl: true,
                      }"
                      ref="itieraryDetailMapRef"
                      map-type-id="terrain"
                      style="height: 500px"
                  >
                  <GMapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :draggable="true"
                    :position="m.position"
                    @dragend="onDragend"
                    :clickable="true"
                  />
                  </GMapMap>
                </div>
            </div>

          <div id="buttons">
              <DxToolbar>
                  <dxItem 
                      location="after"
                      widget="dxButton"
                      @click="onClickSave"
                      :options="{
                          icon: 'save',
                          text: 'Αποθηκευση'
                      }"
                  >
                  </dxItem>
                  <dxItem 
                      location="after" 
                      widget="dxButton"
                      @click="onClickClose"
                      :options="{
                          icon: 'close',
                          text: 'Κλείσιμο'
                      }"
                      >
                  </dxItem>
              </DxToolbar>
        </div>
    </div>
</div>
</template>

<script>

  const URL_SERVICE = NYParameters.Host.URI + 'serres_itinerary'
  const URL_SERVICE_serres_geo_locations = NYParameters.Host.URI + 'serres_geo_locations'

  //Grids
  const URL_SERVICE_serres_itinerary_detail = NYParameters.Host.URI + 'serres_itinerary_detail'

  //SEQUENCE
  const URL_SERVICE_serres_seq_itinerary_nextval_VIEW = NYParameters.Host.URI + 'serres_itinerary_nextval_VIEW'

  //const DATAGRIDREFKEY = 'my-data-grid';  
  const centerOfGreece = { lat: 39.3643, lng: 21.9212 }

  import CustomStore from 'devextreme/data/custom_store';

  import { reactive, onMounted, computed } from 'vue';  
  import 'whatwg-fetch';

  import NYParameters from '../../ny-globals'

  import {
      DxForm, 
      DxLabel,
      DxSimpleItem, 
      DxRequiredRule,
      DxGroupItem
  } from 'devextreme-vue/form';

  import DxDataGrid, {
      DxColumn,
      DxEditing, 
      DxPaging,
      DxPager,
      DxGroupPanel,
      DxSorting,
      DxFilterRow,
      DxHeaderFilter,
      //DxLookup,
  } from 'devextreme-vue/data-grid';

  //import DxMap from 'devextreme-vue/map';

  import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';

  export default {
    name: 'ItineraryForm',
    components: {
      //DxMap,
      DxForm,
      DxLabel,
      DxSimpleItem,
      DxRequiredRule,
      DxDataGrid,
      DxColumn,
      DxEditing,
      DxPaging,
      DxPager,
      DxGroupPanel,
      DxSorting,
      DxFilterRow,
      DxHeaderFilter,
      //DxLookup,
      DxToolbar,
      DxItem,
      DxGroupItem,
    },
    data() {
        return {
            title: "Διαχείριση Τηλεφωνίας",
            calendarOptions: { value: new Date() },
            textAreaOptions: { placeholder: 'Προσθήκη σχολίου..'},
            pageSizes: [5, 10, 20],
            GMAPIKey: NYParameters.googleMapsAPIKey,
            //dataGridRefKey: DATAGRIDREFKEY,
            dateBoxEditorOptions: {
              //pickerType: 'rollers',
              type: 'date',
              displayFormat: 'dd/MM/yyyy',
              dateSerializationFormat: 'yyyy-MM-dd',
              invalidDateMessage: 'Λάθος Ημερομηνία',
              showClearButton: true,
              min: new Date(),
              max: new Date(2030, 11, 31)
            },
            rowIndex: -1,
            centerOfMap: centerOfGreece,
            zoom: 7,
            markers: [{
                position: centerOfGreece,
              }
            ]
        }
    },
    props: {
      itinerary_id: {
          type: Number,
          required: true
      }
    },
    watch: {
      itinerary_id(newValue, oldValue) {
          this.$emit('itinerary_id-value-changed', newValue, oldValue);
          this.loadFormData(newValue);
      }
    },
    setup(props) {
      const gridWidth = computed(() => '100%'); // set the width to 100%
      const maxWidth = computed(() => '1000px'); // set the max-width to 800px
      const state = reactive({
        formData: {},

        LookupCustomDS_serres_geo_locations: new CustomStore({
            key: 'id',
            loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_serres_geo_locations),
        }),

        CustomStoreDetail: new CustomStore({
            key: 'id',
            //loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_serres_itinerary_detail + '?filter=itinerary_id,eq,' + props.itinerary_id),
            insert: (values) => sendRequest(URL_SERVICE_serres_itinerary_detail, 'POST', values),
            update: (key, values) => sendRequest(URL_SERVICE_serres_itinerary_detail + '/' + encodeURIComponent(key), 'PUT', values),
            remove: (key) => sendRequest(URL_SERVICE_serres_itinerary_detail + '/' + encodeURIComponent(key), 'DELETE'),
            byKey: (key) => sendRequest(URL_SERVICE_serres_itinerary_detail + "/" + encodeURIComponent(key)),
        }),

        CustomStore_serres_seq_itinerary_nextval_VIEW:  new CustomStore({
                key: 'id',
                loadMode: 'raw',
                cacheRawData: 'false',
                load: () => sendRequest(URL_SERVICE_serres_seq_itinerary_nextval_VIEW),
        }),

        CustomStoreMain: new CustomStore({
            key: 'id',
            //loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE),
            insert: (values) => sendRequest(URL_SERVICE, 'POST', values),
            update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
            remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
            byKey: (key) => sendRequestByKey(URL_SERVICE + "/" + encodeURIComponent(key)),
        }),
      });

      // 
      //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
      //
      const sendRequest = (url, method = 'GET', values = {}) => {
          //console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          if (method === 'GET') {
                return fetch(url, {
                    method,
                    credentials: 'include',
                })
                .then(response => response.json())
                .then(json => {
                  return json.records;
                })
            }
            return fetch(url, {
                method,
                body: JSON.stringify(values),
                headers: {
                    'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                credentials: 'include',
            }).then((result) => {
                if (result.ok) {
                    return result.text().then((text) => text && JSON.parse(text));
                }
                return result.json().then((json) => {
                    throw json.Message;
                });
            });
      };

      const sendRequestByKey = (url, method = 'GET') => {
          //console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          return fetch(url, {
                    method,
                    headers: {
                        'Accept': 'application/json',
                    },
                    credentials: 'include',
                })
                .then(response => response.json())
      };

      const saveData = async () => {
          // console.log('Save data');
          await state.CustomStoreMain.update(state.formData.id, state.formData);
      };

      const insertData = async () => {
          // console.log('Insert data');
          await state.CustomStoreMain.insert(state.formData);
      };

      const clearForm = () => {
          state.formData = {};
      };

      var isGridValidated = true;
  
      onMounted(async () => {
          //state.formData = await state.CustomStoreMain.byKey(props.itinerary_id);
          if (props.itinerary_id != null) state.formData = await state.CustomStoreMain.byKey(props.itinerary_id);

      });

      return {
          saveData,
          insertData,
          clearForm,
          gridWidth,
          maxWidth,
          state,
          isGridValidated
      };
    },
    methods: {
        async loadFormData(id) {

            if (id != null) {
                this.isInsertMode = false
                this.state.formData = await this.state.CustomStoreMain.byKey(id)

            } else {
                this.getNextVal().then(value => {
                    this.isInsertMode = true
                    this.state.formData = {entry_date: new Date().toISOString().split('T')[0]}
                    this.state.formData.id = value
                })
            }
            this.initialCodeValue = this.state.formData.code
            await this.$refs.gridDetail.instance.refresh()
        },

        async getNextVal() {
            //console.log('getNextVal')
            this.state.CustomStore_serres_seq_itinerary_nextval_VIEW.clearRawDataCache()
            let row = await this.state.CustomStore_serres_seq_itinerary_nextval_VIEW.load()
            return row[0].nextval
        },

        onClickSave: async function() {

            const formValidator = this.dataForm.validate();
            this.isGridValidated = true
            let formSaved = false

            if (formValidator.isValid) {
                if (!this.isInsertMode) {
                    await this.saveData()
                    formSaved = true
                } else {
                    await this.insertData()
                    formSaved = true
                }
            }

            await this.$refs.gridDetail.instance.saveEditData()

            if (this.isGridValidated && formSaved) this.$emit('closePopupEvent', true)

        },
        onClickClose: function() {
            this.$emit('closePopupEvent', true);
        },
        onInitNewRow(row) {
            row.data.itinerary_id = this.state.formData.id;
        },
        onRowValidating(e) {
          this.isGridValidated = this.isGridValidated && e.isValid;
        },
        onFocusedRowChanged(e) {
            console.log("onFocusedRowChanged")
            this.rowIndex = e.row.rowIndex

            const data = e.row && e.row.data

            //const matchResult = data.google_map_point.match(/\((-?\d+\.\d+), (-?\d+\.\d+)\):(\d+)/);
            /*
            const matchResult = data.google_map_point.match(/\(\s*(-?\d+(\.\d+)?)\s*,\s*(-?\d+(\.\d+)?)\s*\):(\d+)/);

            if (matchResult !== null) {
                const [lat, lng, zoom] = matchResult.slice(1).map(Number);
                if (!isNaN(lat) && !isNaN(lng) && !isNaN(zoom)) {

                    console.log(zoom)
                    console.log(lat)
                    console.log(lng)
                    
                    this.zoom = zoom;
                    this.centerOfMap = { lat, lng }
                    this.markers = [{
                        position: this.centerOfMap,
                    }]
                }
            } else {
                console.error("Λάθος μορφή ");
            }*/
            const matchResult = data.google_map_point.match(/\(\s*(-?\d+(\.\d+)?)\s*,\s*(-?\d+(\.\d+)?)\s*\):(\d+)/);

            if (matchResult !== null) {
                // The actual values start from index 1, since index 0 is the full match.
                const lat = Number(matchResult[1]); // This is the latitude
                const lng = Number(matchResult[3]); // This is the longitude (skip index 2 because it's the decimal part of latitude)
                const zoom = Number(matchResult[5]); // This is the zoom level (skip index 4 because it's the decimal part of longitude)

                if (!isNaN(lat) && !isNaN(lng) && !isNaN(zoom)) {
                    console.log(zoom);
                    console.log(lat);
                    console.log(lng);
                    
                    this.zoom = zoom;
                    this.centerOfMap = { lat, lng };
                    this.markers = [{
                        position: this.centerOfMap,
                    }];
                }
            } else {
                console.error("Λάθος μορφή ");
            }
        },
        addMarker(e) {
            console.log("addMarker(e)")
            this.mapMarkers.push({ location: e.location });
        },
        removeMarker() {
          console.log("removeMarker()")
            this.mapMarkers.pop();
        },
        onDragend(e) {
          let lat = e.latLng.lat()
          let lng = e.latLng.lng()
          let zoom = this.$refs.itieraryDetailMapRef.$mapObject.zoom

          if (lat) {
            this.dataGrid.cellValue(this.rowIndex, "google_map_point", `(${lat}, ${lng}):${zoom}`);
          }
          
        }
    },
    computed: {
        dataGrid: function() {
            return this.$refs.gridDetail.instance;
        },
        dataForm: function() {
            return this.$refs.formMaster.instance;
        },
    }
};
</script>

<style lang="scss">

</style>

<style scoped>

/* Targets editing row */
::ng-deep .dx-edit-row {
    box-shadow: 3px 3px 5px 5px #ccc;
}

.grid-map-container {
  display: flex;
  flex-wrap: wrap;
}

.grid {
  flex: 1;
  padding: 10px;
  max-width: 50%; /* Adjust this as needed for the desired width on desktop and tablet */
  box-sizing: border-box;
}

.map {
  flex: 1;
  padding: 4% 2% 5% 2%;;
  max-width: 50%; /* Adjust this as needed for the desired width on desktop and tablet */
  box-sizing: border-box;
}

@media (max-width: 768px) {
  /* Adjust the layout for tablets (e.g., 768px) */
  .grid {
    max-width: 100%; /* Full width for tablets */
  }

  .map {
    max-width: 100%; /* Full width for tablets */
  }
}

#form {
   margin-top: 25px;
}
.caption {
    font-size: 18px;
    font-weight: 500;
}
.option {
    margin-top: 10px;
}
</style>
